/**
 * Hook pour vérifier si l'utilisateur peut accéder à get_users_list
 * Retourne false pour les users simples, true pour admin/superadmin
 */

import { useMemo } from 'react';
import { useAuth } from './useAuth';

export function useCanAccessUsers(): boolean {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user) return false;
    const role = user.app_metadata?.role || 'user';
    return role === 'admin' || role === 'superadmin';
  }, [user]);
}
